import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import Button from 'components/shared/Button';
import useFollowUser from 'sdk/hooks/follow/useFollowUser';
import useUserIsFollowedByMe from 'sdk/hooks/follow/useUserIsFollowedByMe';
import { Link, useNavigate } from 'react-router-dom';
import useProfileById from 'sdk/hooks/user/useProfileById';
import useExpertProfile from 'sdk/hooks/expert/useExpertProfile';
import styles from './ExpertView.module.scss';
import { useTranslation } from 'react-i18next';

let interval: NodeJS.Timeout | undefined

function ExpertView({
  className,
  data,
  isActive,
}: {
  className?: string,
  data: any,
  isActive?: boolean
}) {
  const {t} = useTranslation() as any
  const [isFollowedByMe, setIsFollowedByMe] = useState(false)
  const {
    data: isFollowedByMeData,
    refetch: refetchIsFollowedByMe,
  } = useUserIsFollowedByMe(data?.data?.objectID)
  const followToUser = useFollowUser(data?.data?.objectID)
  const navigate = useNavigate()
  const videoRef = useRef<HTMLVideoElement>(null)
  const video = videoRef?.current
  const [, setVideoProgress] = useState(0)
  const { data: profile } = useProfileById(data?.data?.objectID)
  const { data: expertProfile } = useExpertProfile(profile?.expert_id)

  const getProgress = () => (
    (video && video?.duration) ? (
      ((video?.currentTime || 0) / (video?.duration || 1)) * 100
    ) : 0
  )

  const startVideo = () => {
    if (video) {
      video.play()
      if (interval) clearInterval(interval)
      setVideoProgress(getProgress())
      interval = setInterval(() => setVideoProgress(getProgress()), 1000)
    }
  }

  const stopVideo = () => {
    if (video) {
      video.pause()
      setVideoProgress(getProgress())
      if (interval) clearInterval(interval)
    }
  }

  useEffect(() => () => {
    if (interval) clearInterval(interval)
  }, [])

  useEffect(() => {
    if (!isActive) {
      stopVideo()
    } else {
      startVideo()
    }
  }, [isActive])

  useEffect(() => {
    const videoEl = videoRef.current;
    return () => {
      if (videoEl) {
        videoEl.pause()
      }
    }
  }, [])

  useEffect(() => {
    setIsFollowedByMe(isFollowedByMeData || false)
  }, [isFollowedByMeData])

  const getMedia = (link: string) => {
    if (!link) {
      return ''
    }

    if (link.slice(-3) === 'mp4' || link.slice(-3) === 'mov' || link.slice(-3) === '3gp') {
      return <video ref={videoRef} src={link} muted loop />
    }

    return (
      <img
        src={link}
        alt={link}
      />
    )
  }

  const onFollow = async (e: any) => {
    setIsFollowedByMe(true)
    e.stopPropagation()
    followToUser.mutate(true, {
      onSuccess() {
        refetchIsFollowedByMe()
      },
    })
  }

  const onUnFollow = async (e: any) => {
    setIsFollowedByMe(false)
    e.stopPropagation()
    followToUser.mutate(false, {
      onSuccess() {
        refetchIsFollowedByMe()
      },
    })
  }

  return (
    <div
      className={clsx(
        className,
        styles.containerNew,
      )}
      onClick={() => navigate(`/profile/${data?.data?.username}`)}
    >
      <div className={styles.bg}>{getMedia(expertProfile?.bg_video || data?.data?.bg_cover) }</div>
      <div className={styles.containerInfoTop} />

      <div className={styles.containerInfoBottom}>

        <Link to={`/profile/${data?.data?.username}`} className={styles.firstname}>
          {profile?.first_name}
          {' '}
          {profile?.last_name}
        </Link>

        {
        !isFollowedByMe
          ? (
            <Button
              wide
              secondary
              className={styles.btn}
              onClick={onFollow}
            >
              {t("Follow")}
            </Button>
          )
          : (
            <Button
              wide
              secondary
              className={styles.btn}
              onClick={onUnFollow}
            >
              {t('Following')}
            </Button>
          )
      }

      </div>
    </div>
  )
}

export default ExpertView
